import styled from 'styled-components'
import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import ZaatLogoSvg from '../static/ZaatLogo.svg'
import MenuIcon from '../static/MenuIcon.svg'
import CloseIcon from '../static/CloseIcon.svg'

const Container = styled.nav`
  width: 100%;
  height: ${({ isScrolled }) => (isScrolled ? '50px' : '70px')};
  background: ${({ theme: { colors }, isScrolled }) => (isScrolled ? colors.white : 'transparent')};
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: ${({ isScrolled }) => (isScrolled ? '0px 3px 5px rgba(0, 0, 0, 0.05)' : '0px 3px 5px rgba(0, 0, 0, 0)')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme: { spaces } }) => spaces.small};
  transition: 0.3s ease-out;
  box-sizing: border-box;
  z-index: 5;
`
const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`
const DesktopMenu = styled.ul`
  display: none;
  list-style-type: none;
  flex: 1;
  justify-content: space-evenly;
  align-items: center;
  margin: 0;
  > li {
    > a {
      color: ${({ theme: { colors } }) => colors.gray2};
      text-decoration: none;
      font-size: ${({ theme: { fontSizes }, isScrolled }) => (isScrolled ? fontSizes.medium : fontSizes.normal)};
      transition: 0.3s ease-out;
      font-weight: bold;
    }
  }
  @media (min-width: 679px) {
    display: flex;
  }
`
const DesktopMenuTab = styled.li`
  margin: 0;
  position: relative;
  :after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -3px;
    height: 0px;
    width: 100%;
    background: ${({ theme: { colors } }) => colors.primary};
    border-radius: 6px;
    transition: height 0.15s ease-out;
  }
  :hover {
    > a {
      color: ${({ theme: { colors } }) => colors.primary};
    }
    :after {
      height: 3px;
    }
    > ul {
      display: block;
      visibility: visible;
    }
  }
`

const SubMenu = styled.ul`
  position: absolute;
  list-style-type: none;
  margin: 0;
  background: ${({ theme: { colors } }) => colors.white};
  padding: ${({ theme: { spaces } }) => spaces.small};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  top: 2.6rem;
  left: -1rem;
  min-width: 200px;
  visibility: hidden;
  transition: 0.3s ease-out;
`
const SubMenuItem = styled.li`
  margin: ${({ theme: { spaces } }) => spaces.small} 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  > a {
    color: ${({ theme: { colors } }) => colors.primary};
    text-decoration: none;
    font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};
  }
`
const MobileNavButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  z-index: 6;
  > svg {
    fill: ${({ theme: { colors } }) => colors.gray2};
    height: 15px;
  }
  @media (min-width: 679px) {
    display: none;
  }
`

const MobileMenu = styled.ul`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${({ shouldShow }) => (shouldShow ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  background: linear-gradient(151deg, rgba(42, 182, 64, 1) 0%, rgba(48, 255, 190, 1) 100%);
  animation: anim_in 0.2s ease-out;
  @keyframes anim_in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  > li > a {
    font-size: 0;
    animation: enlargeFont 0.3s 0.5s ease-out forwards;
    @keyframes enlargeFont {
      from {
        font-size: 0;
      }
      to {
        font-size: ${({ theme: { fontSizes } }) => fontSizes.large};
      }
    }
  }
  @media (min-width: 679px) {
    display: none;
  }
  margin: 0;
  padding: 0;
`
const MobileItemTab = styled.li`
  margin: 1rem 0;
  text-align: center;

  > a {
    text-decoration: none;
    color: ${({ theme: { colors } }) => colors.white};
    font-weight: bold;
  }
`

const MobileSubMenu = styled.ul`
  margin: 0;
  list-style-type: none;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  animation: subMenu 0.3s ease-out forwards;
  overflow: hidden;
  @keyframes subMenu {
    from {
      height: 0;
    }
    to {
      height: 100px;
    }
  }
`
const MobileSubMenuItem = styled.li`
  > a {
    color: ${({ theme: { colors } }) => colors.white};
    text-decoration: none;
    font-size: ${({ theme: { fontSizes } }) => fontSizes.noraml};
  }
`
const CloseMenuButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  > svg {
    fill: ${({ theme: { colors } }) => colors.white};
  }
`
const NavbarV2 = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [toggleMobileMenu, setToggleMobileMenu] = useState(false)
  const handleScroll = () => (window.pageYOffset >= 150 ? setIsScrolled(true) : setIsScrolled(false))
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    handleScroll()
  }, [])
  return (
    <Container isScrolled={isScrolled}>
      <LogoContainer to="/">
        <ZaatLogoSvg />
      </LogoContainer>
      <DesktopMenu isScrolled={isScrolled}>
        <DesktopMenuTab>
          <Link to="/">HOME &#10140;</Link>
          <SubMenu>
            <SubMenuItem>
              <Link to="/#services">SERVICES</Link>
            </SubMenuItem>
            <SubMenuItem>
              <Link to="/#portfolio">PORTFOLIO</Link>
            </SubMenuItem>
            <SubMenuItem>
              <Link to="/#team">TEAM</Link>
            </SubMenuItem>
            <SubMenuItem>
              <Link to="/#contact">CONTACT</Link>
            </SubMenuItem>
          </SubMenu>
        </DesktopMenuTab>
        <DesktopMenuTab>
          <Link to="/blog/">BLOG</Link>
        </DesktopMenuTab>
        <DesktopMenuTab>
          <Link to="/podcast/">Podcast</Link>
        </DesktopMenuTab>
        <DesktopMenuTab>
          <Link to="/about/">ABOUT</Link>
        </DesktopMenuTab>
        <DesktopMenuTab>
          <Link to="/faq/">F.A.Q</Link>
        </DesktopMenuTab>
      </DesktopMenu>
      <MobileNavButton onClick={() => setToggleMobileMenu(!toggleMobileMenu)} aria-label="menu">
        <MenuIcon />
      </MobileNavButton>
      <MobileMenu shouldShow={toggleMobileMenu} className="home">
        <MobileItemTab>
          <Link to="/" onClick={() => setToggleMobileMenu(false)}>
            HOME &#10140;
          </Link>
          <MobileSubMenu>
            <MobileSubMenuItem onClick={() => setToggleMobileMenu(false)}>
              <Link to="/#services">SERVICES</Link>
            </MobileSubMenuItem>
            <MobileSubMenuItem onClick={() => setToggleMobileMenu(false)}>
              <Link to="/#portfolio">PORTFOLIO</Link>
            </MobileSubMenuItem>
            <MobileSubMenuItem onClick={() => setToggleMobileMenu(false)}>
              <Link to="/#team">TEAM</Link>
            </MobileSubMenuItem>
            <MobileSubMenuItem onClick={() => setToggleMobileMenu(false)}>
              <Link to="/#contact">CONTACT</Link>
            </MobileSubMenuItem>
          </MobileSubMenu>
        </MobileItemTab>
        <MobileItemTab onClick={() => setToggleMobileMenu(false)}>
          <Link to="/blog/">BLOG</Link>
        </MobileItemTab>
        <MobileItemTab onClick={() => setToggleMobileMenu(false)}>
          <Link to="/podcast/">Podcast</Link>
        </MobileItemTab>
        <MobileItemTab onClick={() => setToggleMobileMenu(false)}>
          <Link to="/about/">ABOUT</Link>
        </MobileItemTab>
        <MobileItemTab onClick={() => setToggleMobileMenu(false)}>
          <Link to="/faq/">F.A.Q</Link>
        </MobileItemTab>
        <CloseMenuButton onClick={() => setToggleMobileMenu(false)}>
          <CloseIcon width="50" />
        </CloseMenuButton>
      </MobileMenu>
    </Container>
  )
}

export default NavbarV2
